export const fwkConst = {
    NEW_ADJUST_URL: "rmej7yso",//新的adjust跳转链接

    // ADJUST_ATTR: "ADJUST_ATTR",//adjust的归因储存

    CHANNEL_ATTR : 'channel_attr_key',
    CHANNEL_QID : 'channel_qid_key',
    CHANNEL_UUID : 'channel_uuid',
    CHANNEL_END_TIME : 'channel_end_time',

    WEB_UUID: "WEB_UUID",//
    H5_UUID: "H5_UUID",

    PWA_STATUS: "PWA_STATUS",//PWA的安装状态
    EVER_INSTALLED:'EVER_INSTALLED',

    SM_BROWSER_ID: "n0xiofzt",
    SM_ID: "SM_ID",
    SM_SESSION_ID: "ofvxtofw",

    GEO_LOCATION_DECRYPT: "g0e00e34v",//GEO解密返回结果
    GEO_ISREADY: "g0e00e34vs",

    guide_install_count: "dci7ad5w",//引导显示次数
}
